import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class ServicesBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cardbox: [
                {
                    id: 1,
                    colspan: [
                        {
                            idx: 1,
                            icon: 'autora-icon-build',
                            title: 'PLYWOOD & MDF BOARDS',
                            text: 'We stock a wide range of plywood in 3mm, 6mm, and 9mm sizes, MDF boards, marine boards, Particle boards (All types) and veneer ply for all your construction and furniture needs.'
                        }
                    ],
                    colleft: [
                        {
                            idx: 1,
                            icon: 'autora-icon-hat-outline',
                            title: 'BLOCK BOARDS & CHIP BOARDS',
                            text: 'High-quality 18mm MDF plain, block boards in various sizes, and chip boards for superior strength and durability in your woodworking projects.',
                        }
                    ]
                },
                {
                    id: 2,
                    colspan: [
                        {
                            idx: 1,
                            icon: 'autora-icon-author-outline',
                            title: 'DOORS & HARDWARE',
                            text: 'Complete selection of flash doors, mahogany doors, hinges, locks, door handles, and all necessary hardware for residential and commercial installations.'
                        }
                    ],
                    colleft: [
                        {
                            idx: 1,
                            icon: 'autora-icon-build-home',
                            title: 'PAINTS & FINISHES',
                            text: 'Premium paints from trusted brands like Seweco, wood finishes, sandpaper in various grits, lipping materials, and Cona adhesives for perfect finishes.',
                        }
                    ]
                },
                {
                    id: 3,
                    colspan: [
                        {
                            idx: 1,
                            icon: 'autora-icon-building-outline',
                            title: 'TOOLS & FASTENERS',
                            text: 'Professional-grade hammers, screwdrivers, pliers, measuring tapes, testers, and complete range of screws including Valida self-tapping screws and concrete nails.'
                        }
                    ],
                    colleft: [
                        {
                            idx: 1,
                            icon: 'autora-icon-hat-outline',
                            title: 'CEMENT & ADHESIVES',
                            text: 'Quality cement brands including Blue Triangle and Nguvi, contact adhesives from Cona and Ponal, and all bonding solutions for your construction needs.',
                        }
                    ]
                }
            ]
        }
    }
    render() {
        return (
            <div className="themesflat-row gutter-30 clearfix">
                {
                    this.state.cardbox.map(data => (
                        <div className="col span_1_of_4" key={data.id}>
                            <div className="themesflat-spacer clearfix" data-desktop={0} data-mobile={35} data-smobile={35} />
                            {
                                data.colspan.map( spandata =>(
                                    <div className="themesflat-icon-box icon-left accent-color style-2 clearfix" key={spandata.idx}>
                                        <div className="icon-wrap">
                                            <i className={spandata.icon} />
                                        </div>
                                        <div className="text-wrap">
                                            <h5 className="heading"><Link to="#">{spandata.title}</Link></h5>
                                            <p className="sub-heading">{spandata.text}</p>
                                        </div>
                                    </div>
                                ))
                            }
                            <div className="themesflat-spacer clearfix" data-desktop={62} data-mobile={35} data-smobile={35} />
                            {
                                data.colleft.map(leftcol => (
                                    <div className="themesflat-icon-box icon-left accent-color style-2 clearfix" key={leftcol.idx}>
                                        <div className="icon-wrap font-size-35 line-height-50">
                                            <i className={leftcol.icon}/>
                                        </div>
                                        <div className="text-wrap">
                                            <h5 className="heading"><Link to="#">{leftcol.title}</Link></h5>
                                            <p className="sub-heading margin-top-18">{leftcol.text}</p>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default ServicesBox;